export default __webpack_public_path__ + "static/media/slide-5.c21ddf1f.jpeg";